// @flow

import * as React from 'react';
import './Paragraph.scss';

type ParagraphProps = {|
  className?: string,
  id?: string,
  children: React.Node,
|};

export const Paragraph = ({className, id, children}: ParagraphProps) => (
  <p id={id} className={className}>
    {children}
  </p>
);
